import * as yup from "yup";

import type { BasicRoute, RouteResponseBody, RouteSchema } from "../../..";
import type { AgrementDto } from "../../../dto/agrement.dto";

export interface GetOneRoute extends BasicRoute {
  path: "/admin/agrements/{agrementId}";
  method: "GET";
  params: {
    agrementId: string;
  };
  response: RouteResponseBody<{
    agrement: AgrementDto | null;
  }>;
}

export const GetOneRouteSchema: RouteSchema<GetOneRoute> = {
  params: yup.object({
    agrementId: yup.string().required(),
  }),
};
